import { combineReducers } from "redux";
import {
  alerts,
  alertsForm,
  app,
  articles,
  authorization,
  components,
  componentsForm,
  componentTypes,
  componentTypesForm,
  contracts,
  contractsForm,
  contractsLoading,
  currentRoute,
  currentTheme,
  deliveryNotes,
  dosificationConfigs,
  dosificationConfigsForm,
  dosificationProducts,
  dosificationProductsForm,
  downloadDocuments,
  equipmentConfigurations,
  equipmentConfigurationsForm,
  equipments,
  equipmentsForm,
  equipmentTypes,
  equipmentTypesForm,
  establishmentInfo,
  establishmentInfoForm,
  expenses,
  expensesForm,
  holidayRequests,
  holidayRequestsForm,
  imputHours,
  imputHoursForm,
  incidences,
  incidencesForm,
  incidenceFollowUps,
  instalations,
  instalationsForm,
  invoices,
  invoicesForm,
  leaves,
  leavesForm,
  maintenances,
  maintenancesForm,
  navCustomers,
  navUsers,
  notifications,
  OPCUA,
  OPCUAForm,
  products,
  profile,
  projects,
  projectsForm,
  reasons,
  reasonsForm,
  repartidors,
  repartiments,
  roles,
  rolesForm,
  salesShipments,
  salesShipmentsForm,
  satisfactions,
  satisfactionsForm,
  securitySheets,
  securitySheetsForm,
  shopCarts,
  shopCartsForm,
  signForm,
  singUps,
  singUpsForm,
  suggestions,
  suggestionsForm,
  tags,
  tagsForm,
  timeRequests,
  timeRequestsForm,
  users,
  usersForm,
  workOrders,
  workOrdersForm,
  workShifts,
  workShiftsForm,
  rapports,
  rapportsForm,
  deliverymen,
} from "./Reducers";

export default combineReducers({
  rapports,
  rapportsForm,
  salesShipments,
  salesShipmentsForm,
  app,
  authorization,
  currentRoute,
  profile,
  notifications,
  usersForm,
  users,
  navCustomers,
  equipmentConfigurations,
  equipmentConfigurationsForm,
  instalations,
  instalationsForm,
  projects,
  projectsForm,
  imputHours,
  imputHoursForm,
  singUps,
  singUpsForm,
  equipments,
  equipmentsForm,
  navUsers,
  incidences,
  incidencesForm,
  incidenceFollowUps,
  satisfactions,
  satisfactionsForm,
  alerts,
  alertsForm,
  shopCarts,
  shopCartsForm,
  articles,
  securitySheets,
  securitySheetsForm,
  invoices,
  invoicesForm,
  deliveryNotes,
  downloadDocuments,
  signForm,
  repartidors,
  repartiments,
  suggestions,
  suggestionsForm,
  establishmentInfo,
  establishmentInfoForm,
  tags,
  tagsForm,
  expenses,
  expensesForm,
  OPCUA,
  OPCUAForm,
  timeRequests,
  timeRequestsForm,
  holidayRequests,
  holidayRequestsForm,
  workShifts,
  workShiftsForm,
  dosificationProducts,
  dosificationProductsForm,
  dosificationConfigs,
  dosificationConfigsForm,
  leaves,
  leavesForm,
  reasons,
  reasonsForm,
  equipmentTypesForm,
  products,
  components,
  componentsForm,
  componentTypes,
  componentTypesForm,
  contracts,
  contractsForm,
  contractsLoading,
  maintenances,
  maintenancesForm,
  workOrders,
  workOrdersForm,
  equipmentTypes,
  rolesForm,
  roles,
  currentTheme,
  deliverymen,
});
